const SummaryTr = () => {
	return (
		<div>
			<h6>Hakkımda:</h6>
			<p>
				2010 yılından 2012 yılında mezun olana kadar üniversitemde kendi bölümümde kısmi süreli çalışan öğrenci olarak çalıştım.
				2010 yılında Erzincan Üniversite'sini kazandıktan bu yana yazılım geliştirme faaliyetlerinde bulundum. 2014 yılında Anadolu Üniversitesi İşletme Fakültesinden mezun oldum.
			</p>
			<p>
				2017 yılına kadar freelancer olarak çalıştım. 2017-2018 yılları arasında Gazi Yazılım şirketini kurup yönettim, 2017 Ağustos ayından 2019 Eylül ayına kadar Beyoğlu
				Kaza Danışmanlık şirketinin kurumsal erp-crm-hrm yazılımının geliştirilmesinde yazılım uzmanı olarak çalıştım. 
			</p>
			<p>
				<strong>8 yıl php, mysql, html, css, javascript ve jquery ile web uygulamaları geliştirdim</strong>
			</p>
			<p>
				<strong>5 yıldır java ve spring framework, mysql, react ve react-native, redux, sqlite on mobile ve javascript ile web uygulamaları, android ve ios uygulamaları geliştirmekteyim. Restful kullanarak ve yazılım tasarım kalıplarını kullanarak yazılım geliştirmekteyim.</strong> Çalıştığım projeler ve ayrıntılar için linkedin'im aşağıda:
			</p>
		</div>
	)
}

export default SummaryTr
